import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
interface DataType {
  key: string;
  summary: string;
  total: string;
}

export const Prices = ({ extrasTotalPrice }: any) => {
  const [t] = useTranslation("common");

  const totalPrice = useSelector((state: any) => state.main.totalPrice);

  const columns: ColumnsType<DataType> = [
    {
      title: `${t("price-summary")}`,
      dataIndex: "summary",
      key: "summary",
      className: "table-header",
    },
    {
      title: " ",
      dataIndex: "total",
      key: "total",
      render: (text) => {
        return <span style={{ color: "#A7A7A7" }}>{text}</span>;
      },
    },
  ];
  const data: DataType[] = [
    {
      key: "1",
      summary: " Unit price ",
      total: totalPrice,
    },
    {
      key: "2",
      summary: "Extras",
      total: `${extrasTotalPrice.toFixed(2)} $`,
    },
    {
      key: "3",
      summary: "Total",
      total: totalPrice + extrasTotalPrice,
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
      />
    </>
  );
};
